import { useSelector } from "react-redux";
import "./PadName.css";

const SheetName = ({ isMobile, showNav, toggleNav }) => {
  const documentInformation = useSelector((state) => state.editor.documentInformation);
  const isTemplateDocument = useSelector((state) => state.editor.isTemplateDocument);
  const templateData = useSelector((state) => state.editor.templateData);
  const documentName = isTemplateDocument ? templateData?.name : documentInformation?.name;

  return (
    <div className="title-container">
      <h1 className="title">{documentName || "New Document"}</h1>
      {isMobile && (
        <button className={`title-toggle ${showNav ? 'open' : ''}`} aria-haspopup="true" aria-expanded={showNav} aria-label="Toggle navigation menu" onClick={(e)=>{ e.stopPropagation(); toggleNav && toggleNav(); }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M6 9L12 15L18 9" stroke="#202124" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default SheetName;
